import { useState } from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import type { SurveysRespondentStrategyInput } from 'generated/resources/datatable.graphql'
import { SurveysEmployeesStrategyLocationsDocument } from 'generated/resources/graphql'

import { EntitySelectWrapper } from 'modules/core/components/EntitySelectWrapper'
import LabeledInput from 'modules/core/components/LabeledInput'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

interface Props {
  strategy: SurveysRespondentStrategyInput
  onChange: (ids: number[]) => void
}

export function LocationsStrategy({ strategy, onChange }: Props) {
  const [skip, setSkip] = useState(true)

  const { data, loading } = useQuery(SurveysEmployeesStrategyLocationsDocument, {
    skip,
  })

  const locationIds = new Set(strategy.arguments || [])
  const locations = data?.locations.locations || []
  const selectedLocations = locations.filter((location) => locationIds.has(location.id))

  return (
    <Box gap="s16">
      <EntitySelectWrapper
        label={i18n.t('surveys.configuration.participants.locations_label')}
        hideLabel
        loading={loading}
        onOpen={() => {
          setSkip(false)
        }}
        entities={locations}
        selectedEntities={selectedLocations}
        value={selectedLocations}
        searchPlaceholder={i18n.t('common.search_by')}
        selectAllLabel={i18n.t('common.select_all')}
        clearLabel={i18n.t('common.clear')}
        selectedLabel={i18n.t('common.selected')}
        notFoundSubtitle={i18n.t('factorial_one.collections.empty_states.no_results.description')}
        notFoundTitle={i18n.t('factorial_one.collections.empty_states.no_results.title')}
        placeholder={i18n.t('common.select')}
        selectedItemsCopy={i18n.t('common.selected')}
        multiple
        onSelectMultiple={(locations) => {
          if (!locations) {
            return
          }

          onChange(locations.map((location) => Number(location.id)))
        }}
        singleSelector={false}
        groups={[]}
        selectedGroup=""
        onSelect={() => {}}
        onGroupChange={() => {}}
        expandedElements={[]}
        selectedGroupedEntities={selectedLocations}
        onSelectExpandedElements={() => {}}
      >
        <Box flexDirection="row" width="full">
          <LabeledInput
            aria-label="employee-selector"
            label={i18n.t('surveys.configuration.participants.locations_label')}
            value={undefined}
          >
            <Box
              paddingX="s16"
              paddingY="s8"
              flexDirection="row"
              height="s40"
              alignItems="center"
              width="full"
            >
              <Box flexDirection="row" width="full" gap="s6">
                <Box overflowX="hidden" textAlign="left">
                  <Text.Normal ellipsis color="grey1000">
                    {selectedLocations.length > 0
                      ? `${selectedLocations.length} ${i18n.t('common.selected')}`
                      : i18n.t('common.select')}
                  </Text.Normal>
                </Box>
              </Box>
              <Icon.Small icon="caret-down" />
            </Box>
          </LabeledInput>
        </Box>
      </EntitySelectWrapper>
    </Box>
  )
}
